// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4586b18f","455":"ea9ac79d","977":"bd501fea"}[chunkId] + ".chunk.js";
};